// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  clauseId: __t.u64().primaryKey().name("clause_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  kind: __t.string(),
  value: __t.i32(),
  status: __t.string(),
  proposedBy: __t.u64().name("proposed_by"),
  rationale: __t.string(),
  voteAt: __t.timestamp().name("vote_at"),
  yesVotes: __t.u32().name("yes_votes"),
  noVotes: __t.u32().name("no_votes"),
  decidedAt: __t.timestamp().name("decided_at"),
});
